import { mix } from "@chorda/core";
export const Icon = (props) => {
    return mix({
        css: 'icon',
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        css: props.css,
        classes: {
            [props.icon]: true
        }
    });
};
